import React, { useState, useEffect } from 'react';
import API, { API_BASE_URL } from '../../constants/config'; // Aapki config file se fetch kiya
import AgentBikesModal from './AgentBikesModal'; // Same folder se import

const AgentManager = () => {
    const [agents, setAgents] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);
    
    // Modals & Preview States
    const [previewImages, setPreviewImages] = useState(null); 
    const [selectedAgentForBikes, setSelectedAgentForBikes] = useState(null);

    const [formData, setFormData] = useState({
        full_name: '', father_name: '', cnic: '', phone: '', address: ''
    });
    const [nicFront, setNicFront] = useState(null);
    const [nicBack, setNicBack] = useState(null);

    // Link Fix: API_BASE_URL (http://localhost:5000/api) se "/api" hata kar images ke liye base banana
    const IMAGE_BASE_URL = API_BASE_URL.replace('/api', ''); 

    useEffect(() => { fetchAgents(); }, []);

    const fetchAgents = async () => {
        try {
            const res = await API.get('/v1/agents');
            setAgents(res.data.data || []);
        } catch (err) { console.error("Error fetching agents", err); }
    };

    const handleViewDocs = (agent) => {
        setPreviewImages({
            front: agent.nic_front ? `${IMAGE_BASE_URL}/${agent.nic_front}` : null,
            back: agent.nic_back ? `${IMAGE_BASE_URL}/${agent.nic_back}` : null,
            name: agent.full_name
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const data = new FormData();
        data.append('full_name', formData.full_name);
        data.append('father_name', formData.father_name);
        data.append('cnic', formData.cnic);
        data.append('phone', formData.phone);
        data.append('address', formData.address);
        if (nicFront) data.append('nic_front', nicFront);
        if (nicBack) data.append('nic_back', nicBack);

        try {
            const res = await API.post('/v1/agents', data);
            if (res.data.success) {
                setShowModal(false);
                setFormData({ full_name: '', father_name: '', cnic: '', phone: '', address: '' });
                fetchAgents();
            }
        } catch (err) { alert("Error saving agent"); }
        finally { setLoading(false); }
    };

    return (
        <div style={styles.container}>
            <div style={styles.header}>
                <h2>🕵️ Commission Agents</h2>
                <button onClick={() => setShowModal(true)} style={styles.addBtn}>+ REGISTER AGENT</button>
            </div>

            <div style={styles.tableCard}>
                <table style={styles.table}>
                    <thead style={styles.thead}>
                        <tr>
                            <th>AGENT NAME</th>
                            <th>CNIC</th>
                            <th>PHONE</th>
                            <th>ADDRESS</th>
                            <th>ACTIONS</th>
                        </tr>
                    </thead>
                    <tbody>
                        {agents.map(agent => (
                            <tr key={agent.id} style={styles.tr}>
                                <td><b>{agent.full_name}</b></td>
                                <td>{agent.cnic}</td>
                                <td>{agent.phone}</td>
                                <td style={{fontSize:'12px'}}>{agent.address}</td>
                                <td>
                                    <div style={{display:'flex', gap:'5px'}}>
                                        <button onClick={() => handleViewDocs(agent)} style={styles.badgeBtn}>👁️ CNIC</button>
                                        <button 
                                            onClick={() => setSelectedAgentForBikes(agent)} 
                                            style={{...styles.badgeBtn, background: '#1e293b'}}
                                        >
                                            🏍️ View Bikes
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* --- AGENT BIKES MODAL (Connect ho gaya) --- */}
            {selectedAgentForBikes && (
                <AgentBikesModal 
                    agent={selectedAgentForBikes} 
                    onClose={() => setSelectedAgentForBikes(null)} 
                />
            )}

            {/* --- IMAGE PREVIEW MODAL --- */}
            {previewImages && (
                <div style={styles.overlay} onClick={() => setPreviewImages(null)}>
                    <div style={styles.imageModal} onClick={e => e.stopPropagation()}>
                        <div style={styles.modalHeader}>
                            <h3>CNIC Documents: {previewImages.name}</h3>
                            <button onClick={() => setPreviewImages(null)} style={styles.closeBtn}>&times;</button>
                        </div>
                        <div style={styles.imageGrid}>
                            <div>
                                <p style={styles.label}>FRONT SIDE</p>
                                {previewImages.front ? <img src={previewImages.front} alt="Front" style={styles.nicImage} /> : <div style={styles.noImage}>No Front Image</div>}
                            </div>
                            <div>
                                <p style={styles.label}>BACK SIDE</p>
                                {previewImages.back ? <img src={previewImages.back} alt="Back" style={styles.nicImage} /> : <div style={styles.noImage}>No Back Image</div>}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* --- ADD AGENT MODAL --- */}
            {showModal && (
                <div style={styles.overlay}>
                    <div style={styles.modal}>
                         <div style={styles.modalHeader}>
                            <h3>Register Agent</h3>
                            <button onClick={() => setShowModal(false)} style={styles.closeBtn}>&times;</button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div style={styles.grid}>
                                <input style={styles.input} placeholder="Name" onChange={e => setFormData({...formData, full_name: e.target.value})} />
                                <input style={styles.input} placeholder="CNIC" onChange={e => setFormData({...formData, cnic: e.target.value})} />
                            </div>
                            <textarea style={{...styles.input, marginTop:'10px', height:'60px'}} placeholder="Address" onChange={e => setFormData({...formData, address: e.target.value})} />
                            <div style={styles.grid}>
                                <input type="file" onChange={e => setNicFront(e.target.files[0])} />
                                <input type="file" onChange={e => setNicBack(e.target.files[0])} />
                            </div>
                            <button type="submit" disabled={loading} style={styles.submitBtn}>
                                {loading ? "Saving..." : "SAVE AGENT"}
                            </button>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

const styles = {
    container: { padding: '20px' },
    header: { display: 'flex', justifyContent: 'space-between', marginBottom: '20px' },
    addBtn: { background: '#2563eb', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer' },
    tableCard: { background: '#fff', borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', overflow: 'hidden' },
    table: { width: '100%', borderCollapse: 'collapse' },
    thead: { background: '#f8fafc', textAlign: 'left' },
    tr: { borderBottom: '1px solid #f1f5f9' },
    badgeBtn: { background: '#3b82f6', color: '#fff', border: 'none', padding: '6px 12px', borderRadius: '6px', fontSize: '12px', cursor: 'pointer' },
    overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 10000 },
    imageModal: { background: '#fff', padding: '25px', borderRadius: '15px', maxWidth: '800px', width: '90%' },
    imageGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginTop: '10px' },
    nicImage: { width: '100%', height: '250px', objectFit: 'contain', borderRadius: '8px', border: '1px solid #ddd' },
    noImage: { height: '250px', background: '#f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '8px', color: '#94a3b8' },
    modalHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' },
    closeBtn: { background: 'none', border: 'none', fontSize: '28px', cursor: 'pointer' },
    label: { fontSize: '12px', fontWeight: 'bold', color: '#64748b', textAlign: 'center' },
    input: { width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd' },
    grid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginTop:'10px' },
    submitBtn: { width: '100%', padding: '12px', background: '#10b981', color: '#fff', border: 'none', borderRadius: '8px', marginTop: '15px', cursor: 'pointer' },
    modal: { background: '#fff', padding: '25px', borderRadius: '15px', width: '500px' }
};

export default AgentManager;